module.exports = __webpack_public_path__ + "img/chapterImage2.52dab497.png";